import React from 'react';

import UserListDrawer from '@src/components/Users/UserListDrawer';
import EventTypesDrawer from '@src/packages/events/components/EventTypesDrawer';
import ReportEventDrawer from '@src/packages/dashboard/components/ReportEventDrawer';

import type { SelectedUsersState } from '../../types';

interface TasksDashboardDrawersProps {
  isTimelineOpen: boolean;
  onCloseTimeline: () => void;
  isEventTypesOpen: boolean;
  onCloseEventTypes: () => void;
  isUserListOpen: boolean;
  onCloseUserList: () => void;
  selectedUsers: SelectedUsersState | null;
  organizationId: string;
  divisionIds: string[];
}

/** Drawers opened from the detail tables: execution timeline, event types and assigned users. */
const TasksDashboardDrawers: React.FC<TasksDashboardDrawersProps> = ({
  isTimelineOpen,
  onCloseTimeline,
  isEventTypesOpen,
  onCloseEventTypes,
  isUserListOpen,
  onCloseUserList,
  selectedUsers,
  organizationId,
  divisionIds,
}) => (
  <>
    {isTimelineOpen && (
      <ReportEventDrawer isVisible={isTimelineOpen} onCancel={onCloseTimeline}
        organizationId={organizationId} divisionIds={divisionIds} scheduleType="task" />
    )}
    {isEventTypesOpen && (
      <EventTypesDrawer isVisible={isEventTypesOpen} onCancel={onCloseEventTypes} />
    )}
    <UserListDrawer
      isVisible={isUserListOpen}
      onCancel={onCloseUserList}
      users={selectedUsers?.users || []}
      groups={selectedUsers?.groups || []}
    />
  </>
);

export default TasksDashboardDrawers;
